// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3CKxY","smallWrapper":"styles_smallWrapper__1Ovm4"};